import $ = require("jquery");
import FeatureLayer = require("arcgis/services/featureserver/layer");
import Query = require("arcgis/services/featureserver/query");
import Utils = require("../../utils");
import Portal = require("portal-gis");
import Converter = require("../../utils/ags/converter");

// FeatureServer/*
class Service {

    static about = `ags discovery and querying services`;

    static discover(args: { url: string }) {

        let converter = new Converter("EPSG:4326", "EPSG:4326");
        let d = $.Deferred<Rhythm.GIS.FeatureQueryResultLayer>();
        let url = args.url;

        $.ajax({
            url: `${url}?f=json`,
            dataType: "text",
            type: "GET",
            proxy: true
        })
            .done((responseText: string, status: string) => {
                let data = JSON.parse(responseText);
                if (data.error) {
                    d.reject({ error: data });
                } else {
                    var featureLayer = <FeatureLayer.RootObject>data;
                    switch (featureLayer.currentVersion) {
                        case "10.3":
                        default: {
                            d.resolve(converter.fromNativeLayer(featureLayer, args));
                            break;
                        }
                    }
                }
            });

        return d;

    }
    
    static query(args: {
        url: string;
        filter?: string;
        options?: any;
    }) {
        let converter = new Converter("EPSG:4326", "EPSG:4326");
        let d = $.Deferred<Rhythm.GIS.FeatureQueryResult>();

        let where = args.filter;

        let outfields = "*";

        let urlParts = args.url.split("/");
        let layerId = urlParts.pop();

        let layerDefs = [{
            layerId: layerId,
            where: where,
            outfields: outfields
        }];

        let queryInfo = {
            layerDefs: layerDefs,
            returnGeometry: false,
            returnIdsOnly: false,
            returnCountOnly: true
        };

        Utils.ifOption(args.options, "returnGeometry", v => queryInfo.returnGeometry = v !== "false");
        Utils.ifOption(args.options, "returnIdsOnly", v => queryInfo.returnIdsOnly = v !== "false");
        Utils.ifOption(args.options, "returnCountOnly", v => queryInfo.returnCountOnly = v !== "false");

        // TODO: study _ code, should be a solution for this already? values? pairs?
        let query = Utils.asOptions(<any>queryInfo).map(item => `${item.id}=${JSON.stringify(item.value) }`).join("&");

        let url = `${urlParts.join("/") }/query?${query}&f=json`;

        console.log("geoquery:", url);

        $.getJSON(url, (data: { error?: any; layers?: Array<FeatureLayer.RootObject> }, status) => {
            if (data.layers) {
                let layers = data.layers.map(l => converter.fromNativeQuery(l));
                d.resolve({
                    layers: layers
                });
            } else if (data.error) {
                console.warn(data.error);
                d.reject(data.error.message);
            } else {
                console.warn("unexpected result format");
                d.reject(data);
            }
        });

        return d;
    }


}

export = Service;

 